/* A browser-history snapshot can predate changes made on the Cart page. */
(() => {
  let request;
  window.addEventListener('pagehide', () => request?.abort());
  window.addEventListener('pageshow', async (event) => {
    if (!event.persisted) return;
    const link = document.querySelector('[data-cart-link]');
    if (!link) return;

    request?.abort();
    const controller = new AbortController();
    request = controller;
    const components = [...document.querySelectorAll('product-card-buy, product-info, cart-items')];
    const version = () => JSON.stringify(components.map((element) => [
      element.cartQuantity, element.revision, !!element.pending, !!element.addPending,
    ]));
    const before = version();
    if (components.some((element) => element.pending || element.addPending)) return;

    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
      url.search = '';
      url.hash = '';
      const response = await fetch(url, {
        headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      // A new purchase or edit owns the next update. Never overwrite it with
      // an older history-restoration response.
      if (request !== controller || controller.signal.aborted || version() !== before) return;

      document.querySelector('product-card-buy')?.syncCart?.(cart);
      document.querySelectorAll('product-info').forEach((product) => product.syncCart?.(cart));

      document.querySelectorAll('[data-cart-link]').forEach((cartLink) => {
        const count = Number(cart.item_count) || 0;
        const badge = cartLink.querySelector('[data-cart-count]');
        if (badge) {
          badge.textContent = String(count);
          badge.hidden = count === 0;
        }
        const label = count === 0 ? cartLink.dataset.cartEmptyLabel :
          count === 1 ? cartLink.dataset.cartOneLabel :
            (cartLink.dataset.cartOtherLabel || '').replace('__COUNT__', String(count));
        cartLink.setAttribute('aria-label', label || '');
      });
      const cartItems = document.querySelector('cart-items');
      if (cartItems?.refresh) await cartItems.refresh(cart);
    } catch {
      // Keep the existing navigation usable when a history refresh is offline.
    } finally {
      if (request === controller) request = null;
    }
  });
})();
